import React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../actions/user';

class Header extends React.Component {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-secondary d-flex justify-content-between">
        <button className="navbar-brand btn btn-secondary" href="#">
          Нушич поръчки
          <span className="badge badge-warning ml-2">{this.props.update_timer}</span>
        </button>
        <button onClick={() => this.props.logout()} className="btn btn-danger">Изход</button>
      </nav>
    );
  }
}

const mapStateToProps = ({update_timer}) => {
  return {
    update_timer
  };
}

const mapDispatchToProps = {logout}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
